export default __webpack_public_path__ + "static/media/i093vk.3e6f134f.webp";